import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import { AdvanceVectoringUserService } from "app/analytic/advance-vectoring-user.service";
import { HighchartsComponent } from "app/modules/shared/highcharts/highcharts.component";
import { ApiService } from "app/modules/shared/services/api.service";
import * as moment from "moment";
import { resolveAxisAnchorDate } from 'app/shared/utils/analytics-axis.util';
import { Subject, Subscription, debounceTime, distinctUntilChanged } from "rxjs";
import { UsageAnalytics } from "../../analytic/graph-tab-data-analytics/UsageAnalytics";
import * as FileSaver from "file-saver";
import { CryptoService } from "app/shared/utils/crypto.service";

@Component({
  selector: "app-basic-vectoring-levelwise",
  templateUrl: "./basic-vectoring-levelwise.component.html",
  styleUrls: ["./basic-vectoring-levelwise.component.scss"],
})
export class BasicVectoringLevelwiseComponent implements OnInit, OnDestroy {
  // ***************SG-7147 strat  *******************

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(HighchartsComponent, { static: false }) highchartsComponent: HighchartsComponent;

  pageSize: number = 5;
  displayedColumns: string[] = ["sessionDate", "excellentHits", "goodHits", "missedHits", "voiceCommands", "textCommands", "status"];
  dataSource: MatTableDataSource<any>;
  dateType: { type: string; from: string; to: string; count: number };
  usageAnalyticsSelectedValue: string = "All";
  totalLessionsSessions = 7;
  updateChart = false;

  usageEramAnalytics: UsageAnalytics[] = [
    { viewValue: "All", value: "All" },
    { viewValue: "Average Lessons Duration", value: "AvgSessionDuration" },
    { viewValue: "Total Lessons Sessions", value: "TotalSessions" },
    { viewValue: "Total Cleared Lessons", value: "ClearedSessions" },

    { viewValue: "Total Not Cleared Lessons", value: "FailedSessions" },
    { viewValue: "Total Voice Commands", value: "VoiceCommands" },
    { viewValue: "Total Text Commands", value: "TextCommands" },
  ];
  userName: any;
  appData: any;
  missionName: any;
  lessonType: any;
  dateInfo: any;
  @Input() dateData$: Subject<any>;
  subSink: Subscription;
  startDate: string;
  endDate: string;
  missionRecords: any[] = [];
  usageType: any = "All";
  sessionPlayedChartLabels: any[];
  sessionPlayedChartDatasets: { data: any; label: string }[];
  graphAPIResponse: any;
  levelType: any;

  constructor(private service: AdvanceVectoringUserService, private route: ActivatedRoute, private api: ApiService, private crypto: CryptoService) {}

  ngOnInit(): void {
    this.api.showDateSelector = true;
    this.userName = localStorage.getItem("nickName");

    this.missionName = this.route.snapshot.params["missionName"];
    let missionData = localStorage.getItem("selectedApp");
    this.appData = JSON.parse(missionData);
    this.lessonType = JSON.parse(missionData).lessonType;
    this.levelType = JSON.parse(missionData).levelType;
    this.dateInfo = JSON.parse(localStorage.getItem("dateRange"));
    this.subSink = this.api.dateRange$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((next) => {
      if (next) {
        if (this.dateInfo) {
          next = this.dateInfo;
        }

        this.dateType = { type: "", from: "", to: "", count: 0 };
        this.dateType.type = next.type ? next.type.toLowerCase() : "day";
        this.dateType.from = next.from ? next.from : moment(new Date()).format("YYYY-MM-DD");
        this.dateType.to = next.to ? next.to : moment(new Date()).subtract(30, "days");
        this.dateType.count = next.count ? next.count : 30;
        this.startDate = moment(next.startDate).format("YYYY-MM-DD");
        this.endDate = moment(next.endDate).format("YYYY-MM-DD");
        // this.initialLoad();
        this.updateChart = false;
        this.getLessonDataBasicVectoring();
        this.getLevelwiseBasicVectoringGraph();
      }
    });
  }

  async getLessonDataBasicVectoring() {
    let nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);

    this.service
      .getUserLevelWiseUserData(this.dateType.type, this.lessonType.replace("[", "%5B").replace("]", "%5D"), nameStr, this.startDate, this.endDate, this.levelType)
      .subscribe((response: any) => {
        this.missionRecords = response;
        this.dataSource = new MatTableDataSource(this.missionRecords);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      });
  }

  changeAnalytics(event) {
    this.usageType = event;
    this.updateChart = false;
    this.getLevelwiseBasicVectoringGraph();
  }

  async exportCsvData(usage) {
    let type = this.dateType.type.toLowerCase();
    let nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);

    if (usage == "performance") {
      this.service
        .downLoadLevelWiseBasicRecords(this.dateType.type, this.lessonType.replace("[", "%5B").replace("]", "%5D"), nameStr, this.startDate, this.endDate, this.levelType)
        .subscribe((data) => {
          let dataObject: any = data;
          if (data.type === "application/zip") {
            var blob = new Blob([data], { type: data.type });
            FileSaver.saveAs(blob, usage.toUpperCase() + ".zip");
          } else {
            var blob = new Blob([data], { type: "application/csv" });
            FileSaver.saveAs(blob, usage.toUpperCase() + ".csv");
          }
        });
    } else {
      this.service
        .downLoadLevelWiseBasicGraph(this.dateType.type, this.lessonType.replace("[", "%5B").replace("]", "%5D"), nameStr, this.usageType, this.startDate, this.endDate, this.levelType)
        .subscribe((data) => {
          if (data.type === "application/zip") {
            var blob = new Blob([data], { type: data.type });
            FileSaver.saveAs(blob, usage.toUpperCase() + ".zip");
          } else {
            var blob = new Blob([data], { type: "application/csv" });
            FileSaver.saveAs(blob, usage.toUpperCase() + ".csv");
          }
        });
    }
  }

  onPageChange(event) {
    this.pageSize = event.pageSize;
    // this.paginateDate();
    this.dataSource = new MatTableDataSource(this.missionRecords);

    this.dataSource.paginator = this.paginator;
  }

  getLastThirtyDaysDefault(data) {
    let daysDate = [];
    // SG-8323 (Issue 8): anchor the axis to the date that was requested rather than the
    // browser clock, so a client/server disagreement about "today" cannot shift every label.
    const anchorDate = resolveAxisAnchorDate(data);
    for (let i = 0; i <= data.count; i++) {
      let date = new Date(anchorDate);
      if (data.type === "month" || data.type === "Month") {
        const selectedMonth = moment(date).subtract(i, "months");
        daysDate.push(moment(selectedMonth).format("MMM YYYY"));
      } else if (data.type === "year" || data.type === "Year") {
        var selectedYear = moment(date).subtract(i, "years");
        daysDate.push(moment(selectedYear).format("YYYY"));
      } else {
        date.setDate(date.getDate() - i);
        daysDate.push(moment(date).format("ddd, MMM D"));
      }
    }
    return daysDate.reverse();
  }

  getLastTwentyFourMonthDefault(date) {
    let months = [];
    for (var i = 0; i < 24; i++) {
      var selectedMonth = moment(date).subtract(i, "months");
      months.push(moment(selectedMonth).format("MMM YYYY"));
    }
    return months.reverse();
  }

  getLastFiveYearsDefault(date) {
    let years = [];
    for (var i = 0; i < 5; i++) {
      var selectedYear = moment(date).subtract(i, "years");
      years.push(moment(selectedYear).format("YYYY"));
    }
    return years.reverse();
  }

  getDatesBetweenStartAndEndDefault(startDate, endDate) {
    let date = [];
    while (moment(startDate) <= moment(endDate)) {
      date.push(moment(startDate).format("ddd, MMM D"));
      startDate = moment(startDate).add(1, "days").format("YYYY-MM-DD");
    }
    return date;
  }

  getLastThirtyDays(timepointPlayed: string[]): string[] {
    return timepointPlayed.map(dateStr => {
      const [month, day, year] = dateStr.split("-").map(Number);
      const date = new Date(year, month - 1, day);

      return date.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric"
      });
    });
  }
  
  getLastTwentyFourMonth(timepointPlayed: string[]): string[] {
      return timepointPlayed.map(dateStr => {
        const [month, year] = dateStr.split("-").map(Number);
        const date = new Date(year, month - 1);
  
        return date.toLocaleDateString("en-US", {
          month: "short",
          year: "numeric"
        });
      });
  }
  
  getDatesBetweenStartAndEnd(timepointPlayed: string[]): string[] {
      return timepointPlayed.map(dateStr => {
        const [month, day, year] = dateStr.split("-").map(Number);
        const date = new Date(year, month - 1, day);
  
        return date.toLocaleDateString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric"
        });
      });
  }

  async getLevelwiseBasicVectoringGraph() {
    let nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);

    this.service
      .getLvelBasicVectoringGraph(this.dateType.type.toLowerCase(), this.lessonType.replace("[", "%5B").replace("]", "%5D"), nameStr, this.usageType, this.startDate, this.endDate, this.levelType)
      .subscribe((response) => {
        this.graphAPIResponse = response;
        this.getGraphConfiguration();
      });
  }

  getGraphConfiguration() {
    if (this.dateType.type == "day") {
      this.dateType = { type: "day", from: moment(new Date()).format("YYYY-MM-DD"), to: moment(new Date()).subtract(30, "days").format("YYYY-MM-DD"), count: 30 };

      this.sessionPlayedChartLabels = this.getLastThirtyDaysDefault(this.dateType);
    } else if (this.dateType.type == "month") {
      this.sessionPlayedChartLabels = this.getLastTwentyFourMonthDefault(this.dateType.from);
    } else if (this.dateType.type == "year") {
      this.sessionPlayedChartLabels = this.getLastFiveYearsDefault(this.dateType.from);
    } else if (this.dateType.type == "range") {
      let selectedFromDate = this.startDate;
      let selectedEndDate = this.endDate;
      this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEndDefault(selectedFromDate, selectedEndDate);
    }
    let AvgSessionDuration = this.graphAPIResponse[0].AvgSessionDuration ? this.graphAPIResponse[0].AvgSessionDuration.map((v) => Number(v)) : this.graphAPIResponse[0].AvgSessionDuration;
    let ClearedSessions = this.graphAPIResponse[0].ClearedSessions ? this.graphAPIResponse[0].ClearedSessions.map((v) => Number(v)) : this.graphAPIResponse[0].ClearedSessions;
    let FailedSessions = this.graphAPIResponse[0].FailedSessions ? this.graphAPIResponse[0].FailedSessions.map((v) => Number(v)) : this.graphAPIResponse[0].FailedSessions;
    let TextCommands = this.graphAPIResponse[0].TextCommands ? this.graphAPIResponse[0].TextCommands.map((v) => Number(v)) : this.graphAPIResponse[0].TextCommands;
    let TotalSessions = this.graphAPIResponse[0].TotalSessions ? this.graphAPIResponse[0].TotalSessions.map((v) => Number(v)) : this.graphAPIResponse[0].TotalSessions;
    let VoiceCommands = this.graphAPIResponse[0].VoiceCommands ? this.graphAPIResponse[0].VoiceCommands.map((v) => Number(v)) : this.graphAPIResponse[0].VoiceCommands;

    this.sessionPlayedChartDatasets = [];

    if (this.usageType == "All" || this.usageType == "AvgSessionDuration") {
      this.sessionPlayedChartDatasets.push({ data: AvgSessionDuration, label: "Average Missions Duration" });
    }
    if (this.usageType == "All" || this.usageType == "TotalSessions") {
      this.sessionPlayedChartDatasets.push({ data: TotalSessions, label: "Total Missions Sessions" });
    }
    if (this.usageType == "All" || this.usageType == "ClearedSessions") {
      this.sessionPlayedChartDatasets.push({ data: ClearedSessions, label: "Total Cleared Missions" });
    }
    if (this.usageType == "All" || this.usageType == "FailedSessions") {
      this.sessionPlayedChartDatasets.push({ data: FailedSessions, label: "Total Not Cleared Missions" });
    }
    if (this.usageType == "All" || this.usageType == "VoiceCommands") {
      this.sessionPlayedChartDatasets.push({ data: VoiceCommands, label: "Total Voice Commands" });
    }
    if (this.usageType == "All" || this.usageType == "TextCommands") {
      this.sessionPlayedChartDatasets.push({ data: TextCommands, label: "Total Text Commands" });
    }

    const timepointPlayed = this.graphAPIResponse?.[0]?.["Timepoint"];
    if (timepointPlayed) {
      if (this.dateType.type == "day") {
        this.sessionPlayedChartLabels = this.getLastThirtyDays(timepointPlayed);
      } else if (this.dateType.type == "month") {
        this.sessionPlayedChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
      } else if (this.dateType.type == "year") {
        this.sessionPlayedChartLabels = timepointPlayed;
      } else if (this.dateType.type == "range") {
        this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
      }
    }

    this.updateChart = true;
    this.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
    this.dateInfo = undefined;
  }

  updateChartData(label: string[], dataset: any) {
    this.highchartsComponent.updateChartData(label, dataset);
  }

  ngOnDestroy(): void {
    if (this.subSink) this.subSink.unsubscribe();
  }
  // ***************SG-7147 end  *******************
}
